/**
 * Адреса HTTP-части API и передача файлов по подписанным ссылкам.
 *
 * По HTTP идут только вход, ротация токена и байты файлов (решение 1).
 * Основание — тот же источник, откуда взята страница; в разработке,
 * где фронтенд и API на разных портах, его задаёт VITE_HTTP_URL.
 *
 * Источник подставляется явно, а не остаётся пустой строкой: относительный
 * адрес понимает только браузер, в тестах fetch("/…") падает на разборе.
 */

import { BASE_PATH } from "./basePath";

// Префикс нужен и здесь: сервер отдаёт ссылки от корня приложения («/files/…»).
const HTTP_BASE = import.meta.env.VITE_HTTP_URL || `${window.location.origin}${BASE_PATH}`;

export function apiUrl(path: string): string {
  return `${HTTP_BASE}${path}`;
}

/** Ссылка от сервера может быть относительной («/files/…») — делаем полной. */
export function resolveApiUrl(url: string | null | undefined): string | null {
  if (url === null || url === undefined || url === "") return null;
  return url.startsWith("/") ? apiUrl(url) : url;
}

/** Байты файла по подписанной ссылке, полученной методом requestUpload. */
export async function uploadSigned(uploadUrl: string, file: Blob): Promise<void> {
  const response = await fetch(apiUrl(uploadUrl), {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type || "application/octet-stream" },
  });
  if (!response.ok) {
    // 413 — файл отсечён ещё прокси; сообщение сервера важнее кода.
    const body = (await response.json().catch(() => null)) as { message?: string } | null;
    throw new Error(
      response.status === 413
        ? "Файл слишком большой"
        : (body?.message ?? `Загрузка не удалась (${String(response.status)})`),
    );
  }
}
